/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import isNonProduction from 'utilities/isNonProduction';
import { apiVersion, baseUrl } from './ShoppingApi';
import WebCheckoutCreateRequestPayPalType from '../types/request/WebCheckoutCreateRequestPayPalType';
import WebCheckoutCreateResponsePayPalType from '../types/response/WebCheckoutCreateResponsePayPalType';

/**
 * Post payment
 * @param referenceKey
 * @param request
 */
async function postWebCheckoutCreatePayPal(
  referenceKey: string,
  request: WebCheckoutCreateRequestPayPalType
): Promise<WebCheckoutCreateResponsePayPalType> {
  const url = `${baseUrl}/${apiVersion}/invoices/${referenceKey}/create-paypal-order`;
  const errorDisplayMessage = 'Unable to process transaction.';

  const requestBody: WebCheckoutCreateRequestPayPalType = {
    ...request,
    shippingAddress: request.shippingAddress
      ? {
          ...request.shippingAddress,
          country: 'US',
        }
      : undefined,
  };

  try {
    const response = await fetch(url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });
    const responseBody =
      (await response.json()) as WebCheckoutCreateResponsePayPalType;

    if (isNonProduction) {
      console.log(
        `webcheckout PayPal response: ${JSON.stringify(responseBody, null, 2)}`
      );
    }
    if (!response.ok) {
      const level = response.status >= 500 ? 'error' : 'warning';

      Sentry.withScope((scope) => {
        scope.setLevel(level);
        Sentry.captureMessage(
          `${level} - ${response.status}: webcheckout PayPal - ${response.statusText}`
        );
      });

      throw new Error(
        `Response status: ${response.status} ${response.statusText}`
      );
    }

    return responseBody;
  } catch (e) {
    throw new Error(`Network error: ${errorDisplayMessage}`);
  }
}

export default postWebCheckoutCreatePayPal;
